// extracted by mini-css-extract-plugin
export default {"container":"Header_container__SR+kB","text-container":"Header_text-container__oBXPP","backButton":"Header_backButton__R4l9p"};